import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const contact = createApi({
  reducerPath: "contact",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.anclatechs.com/",
    // baseUrl: "http://localhost:8000"
  }),
  endpoints: (build) => ({
    updatePost: build.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: ({ id, ...patch }) => ({
        url: "/contact/contact-us",
        method: "POST",
        body: patch,
      }),
      // Pick out data and prevent nested properties in a hook or selector
      transformResponse: (response) => response.data,
      invalidatesTags: ["Post"],
    }),
    postSubscription: build.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: ({ id, ...patch }) => ({
        url: "/contact/subscribe",
        method: "POST",
        body: patch,
      }),
      // Pick out data and prevent nested properties in a hook or selector
      transformResponse: (response) => response.data,
      invalidatesTags: ["Post"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUpdatePostMutation, usePostSubscriptionMutation } = contact;
